import { useRouter } from 'next/router'
import { useSearchParams } from 'next/navigation'
import {
  useCheckoutAnalyticsChannel,
  useViewOrderAnalyticsChannel,
} from '~/hooks/useOrderAnalyticsChannel'
import { getGtmChannelFromUrlPath } from '~/utils/googleTagManager/googleTagManagerHelpers'

const CHECKOUT_ROUTES = [
  '/orders/payment-options',
  '/orders/traveller-details',
  '/orders/additional-details',
  '/orders/payment',
  '/orders/booking-status',
]

export const useChannel = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const isCheckoutPage = CHECKOUT_ROUTES.some((routeMatch) => router.pathname.includes(routeMatch))
  const checkoutChannel = useCheckoutAnalyticsChannel({ isEnabled: isCheckoutPage })

  const isViewOrderPage = router.pathname.includes('view-booking')
  const orderId = isViewOrderPage ? searchParams?.get('bookingId')?.toString() : undefined
  const viewOrderChannel = useViewOrderAnalyticsChannel({ orderId })

  if (isViewOrderPage) {
    return viewOrderChannel
  }

  if (isCheckoutPage) {
    return checkoutChannel
  }

  const productChannel = getGtmChannelFromUrlPath(router.asPath)
  if (productChannel) {
    return productChannel
  }

  const isOrderHistory = router.pathname.includes('/order-history')
  if (isOrderHistory) {
    return ''
  }

  return undefined
}
